export default __webpack_public_path__ + "static/media/searching.9ba2a95a.png";